import colors from '../../../elementaree/src/styles/variables/ui-colors.scss';

export default colors;
